import PropTypes from 'prop-types';
import { Button as AntButton } from 'antd';
import cs from 'classnames';

import s from './Button.module.less';

const Button = props => {
  const { className } = props;
  return <AntButton {...props} className={cs(s.button, className)}></AntButton>;
};

Button.propTypes = {
  ...AntButton.propTypes,
  className: PropTypes.string,
};

Button.defaultProps = {
  className: undefined,
};

export default Button;
